import type { SaveState } from '../shared';
const record = (value: unknown): Record<string, unknown> => value && typeof value === 'object' ? value as Record<string, unknown> : {};
/** Only unfinished activities get a continuation link; results remain on their own screens. */
export function resumeActivities(slices: SaveState['slices']): Array<{ key: string; route: string }> {
  const result: Array<{ key: string; route: string }> = [];
  const duel = record(slices.combat.active), state = record(duel.state);
  if (typeof duel.id === 'string' && state.winner === null) result.push({ key: 'arena', route: `#/arena/fight/${encodeURIComponent(duel.id)}` });
  if (record(slices.exploration.run).status === 'active') result.push({ key: 'road', route: '#/road' });
  if (['playing', 'round'].includes(String(record(slices.cards.match).status))) result.push({ key: 'cards', route: '#/cards/match' });
  if (record(slices.cards.race).status === 'racing') result.push({ key: 'race', route: '#/snails' });
  return result;
}
